import React from "react";
import Header from "../../Components/Header";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/indes";
import "./Home.css";

function Home() {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className="myContainer">
        <div className="heading-container">
          <h1 className="heading">FARMAN AND SONS</h1>
          <span className="heading-span">ELECTRICAL SERVICES</span>
          <div className="buttons">
            <button className="button-learn" onClick={() => navigate("about")}>
              LEARN MORE
            </button>
            <button
              className="button-product"
              onClick={() => navigate("product")}
            >
              OUR PRODUCTS
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Home;
